import { type Bcp47Locale, LOCALES } from '@backmarket/http-api'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

/**
 * Extracts the locale from a URL path.
 * Examples:
 *   "/en-us/page"       => "en-us"
 *   "/es-us?query=1"    => "es-us"
 *
 * Assumes that the locale is the first segment of the path.
 *
 * @param path - The URL path to parse
 * @returns The locale if present, otherwise null
 */
export const getLocaleFromPath = (path: string): Bcp47Locale | null => {
  const supportedLocales = Object.values(LOCALES).map(toBcp47Locale)

  // Remove the query string, if any
  // Example: '/es-us/page?x=1' -> '/es-us/page'
  const pathWithoutQuery = path.split('?')[0] ?? path

  // Split the path into segments and remove empty strings
  // Example: '/es-us/page' -> ['es-us', 'page']
  const segments = pathWithoutQuery.split('/').filter(Boolean)

  const firstSegment = segments[0]

  return firstSegment && supportedLocales.includes(firstSegment as Bcp47Locale)
    ? (firstSegment as Bcp47Locale)
    : null
}
